export default __webpack_public_path__ + "static/media/refresh_white.c9cb7b58.svg";